import { Inertia } from "@inertiajs/inertia";
import classNames from "classnames";
import React, { useMemo, useState } from "react";
import { ChevronDown } from "react-feather";
import { convertToHumanReadable } from "@/Utilities/Utilities";

/**
 * Convert numbers into human readable format
 *
 * @param val
 * @param label
 * @returns {*|number}
 */
const filterValueHook = (val, label = "") => {
  if (Number.isFinite(val)) {
    return convertToHumanReadable(val);
  }
  return val;
};

export const SortableTable = ({
  columns,
  data,
  limit,
  className = "",
  itemClass = "",
  externalValueModifier = filterValueHook,
}) => {
  const [sortConfig, setSortConfig] = useState(null);

  const sortedData = useMemo(() => {
    const sortableData = [...data];
    if (sortConfig !== null) {
      sortableData.sort((a, b) => {
        if (a[sortConfig.key] < b[sortConfig.key]) {
          return sortConfig.direction === "ascending" ? -1 : 1;
        }
        if (a[sortConfig.key] > b[sortConfig.key]) {
          return sortConfig.direction === "ascending" ? 1 : -1;
        }
        return 0;
      });
    }
    return Number.isFinite(limit) ? sortableData.slice(0, limit) : sortableData;
  }, [data, sortConfig, limit]);

  const requestSort = (key) => {
    let direction = "ascending";
    if (
      sortConfig &&
      sortConfig.key === key &&
      sortConfig.direction === "ascending"
    ) {
      direction = "descending";
    }
    setSortConfig({ key, direction });
  };

  return (
    <table className={`min-w-full ${className}`}>
      <thead>
        <tr>
          {columns.map((column, index) => (
            <th
              key={`${column.key}_${index}`}
              className={`cursor-pointer whitespace-nowrap py-2 pr-6 text-left ${
                sortConfig?.key === column.key
                  ? ""
                  : "underline hover:no-underline"
              }`}
              onClick={() => requestSort(column.key)}
            >
              {column.label}
              <ChevronDown
                className={`ml-2 inline-block transition-transform ${
                  sortConfig?.key === column.key ? "visible" : "invisible"
                } ${sortConfig?.direction === "ascending" ? "rotate-180" : ""}`}
              />
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {sortedData.map((row, index) => (
          <tr key={`${row.id}_${index}`}>
            {columns.map((column) => {
              return column.label === "Team" && row.link ? (
                <td
                  key={`${row.id}-${column.key}`}
                  className={classNames(
                    itemClass,
                    "cursor-pointer whitespace-nowrap pb-2 pr-6 align-top underline hover:no-underline",
                  )}
                  // navigate to link with inertia
                  onClick={() => {
                    Inertia.visit(row.link);
                  }}
                  dangerouslySetInnerHTML={{
                    __html: externalValueModifier(
                      row[column.key],
                      column.label,
                    ),
                  }}
                />
              ) : (
                <td
                  key={`${row.id}-${column.key}`}
                  className={classNames(
                    itemClass,
                    "whitespace-nowrap pb-2 pr-6 align-top",
                  )}
                  dangerouslySetInnerHTML={{
                    __html: externalValueModifier(
                      row[column.key],
                      column.label,
                    ),
                  }}
                />
              );
            })}
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default SortableTable;
